import AlertConfigurationList from "./AlertConfigurationList";

export default AlertConfigurationList;
